import { useEffect } from "react";
import { useResourceContext } from "react-admin";
import { useLocation } from "react-router-dom";
import Clarity from "@microsoft/clarity";

const clarityProjectId = import.meta.env.VITE_MS_CLARITY_PROJECT_ID;

const getViewType = (pathname: string): string => {
  if (pathname.includes("/create")) return "create";
  if (pathname.includes("/edit")) return "edit";
  if (pathname.includes("/show") || pathname.match(/\/\d+$/)) return "show";
  return "list";
};

export const ClarityResourceTracker = () => {
  const resource = useResourceContext();
  const location = useLocation();

  useEffect(() => {
    if (!clarityProjectId || !resource) return;

    const viewType = getViewType(location.pathname);

    Clarity.setTag("resource", resource);
    Clarity.setTag("viewType", viewType);
  }, [resource, location.pathname]);

  return null;
};
